/**
 * 品牌相关的单一来源。
 *
 * logo 此前散落在 defaultSettings、登录页、注册页、OAuth 授权页共 5 处；
 * 主色此前只在 defaultSettings 里定义，而 antd 的 ConfigProvider 只配了字体，
 * 于是页面里又出现了手工对齐的 #1890ff 字面量。集中到这里，两边都从这里取。
 */
export const BRAND_LOGO = 'https://image.korsmet.shop/s_logo.png';

export const BRAND_TITLE = 'Korsmet Auth';

/**
 * 全站主色。改这里即可同时影响 ProLayout 与 antd 组件。
 *
 * 从 antd 默认的拂晓蓝 #1890FF 换成 #1266E0：拂晓蓝明度偏高，铺成大色块偏亮偏飘，
 * 深一档更稳，也和登录/授权页统一 —— 之前后台和认证页是两个不同的蓝。
 */
export const BRAND_PRIMARY_COLOR = '#1266E0';

/**
 * 品牌字拆成两段：`Korsmet` 是公司，`Auth` 是产品。
 *
 * 渲染时后半段上色 —— 同一个前缀、不同后缀色区分产品族成员
 * （Adobe / Microsoft 365 都是这个路子）。BRAND_TITLE 仍是拼好的整串，
 * 给文档标题、img alt 这类只能吃纯文本的地方用。
 */
export const BRAND_NAME = 'Korsmet';
export const BRAND_PRODUCT = 'Auth';

/**
 * 产品后缀的颜色。当前和全站主色同值，但语义不同：它是 **Auth 这个产品的身份色**，
 * 登录/授权页也使用 Auth 默认品牌色；平台自定义颜色只用于 App 图标背景。
 */
export const BRAND_PRODUCT_COLOR = BRAND_PRIMARY_COLOR;
